import React from 'react';
import { guarantee } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="guarantee-title" className="bg-teal-tint py-12 md:py-16" data-id="element-81" data-mp="4uqe0xagm4tu">
      <div className="mx-auto flex max-w-[860px] flex-col items-center gap-6 px-5 text-center md:flex-row md:gap-10 md:px-8 md:text-left" data-id="element-82" data-mp="9umfopvopk68">
        <div className="flex h-36 w-36 shrink-0 items-center justify-center rounded-full border-[3px] border-gold p-1.5" aria-hidden="true" data-id="element-83" data-mp="eu8u32n916gm">
          <div className="flex h-full w-full flex-col items-center justify-center rounded-full bg-teal" data-id="element-84" data-mp="jqpr6mcfev5u">
            <span className="font-display text-[1.9rem] font-extrabold leading-none text-gold" data-id="element-85" data-mp="skudqtkj1kfk">{guarantee.sealTop}</span>
            <span className="mt-1.5 font-display text-[10px] font-bold tracking-[0.12em] text-white" data-id="element-86" data-mp="xkgwfij4jsvr">{guarantee.sealBottom}</span>
          </div>
        </div>
        <div data-id="element-87" data-mp="12gxje9el8179">
          <h3 id="guarantee-title" className="font-display text-[1.35rem] font-extrabold uppercase leading-tight tracking-tight text-teal md:text-[1.8rem]" data-id="element-88" data-mp="17i4p82x66qba">
            {guarantee.title}
          </h3>
          <p className="mt-3 text-[16px] leading-relaxed text-ink/75 md:text-[17px]" data-id="element-89" data-mp="20rsrsv0znv7p">{guarantee.text}</p>
        </div>
      </div>
    </section>;
}